<script lang="ts" setup>
useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { name: 'description', content: 'Game Studio is a platform for creating and sharing games.' }
  ],
  link: [
    { rel: 'icon', type: 'image/png', href: '/favicon.png' }
  ],
  htmlAttrs: {
    lang: 'pt-BR'
  }
})
</script>

<template>
  <UApp>
    <NuxtLayout>
      <UMain class="relative">
        <NuxtPage />
      </UMain>
    </NuxtLayout>

    <ClientOnly>
      <LazyUContentSearch
        shortcut="meta_k"
        :navigation="navLinks"
        :color-mode="false"
        :fuse="{ resultsLimit: 42 }"
        :ui="{
          modal: 'bg-gradient-to-br from-wine-500 via-wine-700/80 to-wine-950/10 rounded-3xl',
          input: '[&>input::placeholder]:text-slate-300'
        }"
      />
    </ClientOnly>
  </UApp>
</template>
